var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3405_6842",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.10352e-05H19.9999V20H0V6.10352e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3405_6842)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5568 19.4999C10.4396 19.6959 10.228 19.8158 9.99972 19.8158C9.77141 19.8158 9.55988 19.6959 9.44266 19.4999L7.4004 16.0864C4.16738 15.001 1.83691 11.9472 1.83691 8.34698C1.83691 3.83878 5.49152 0.184168 9.99972 0.184168C14.5079 0.184168 18.1625 3.83878 18.1625 8.34698C18.1625 11.9472 15.8321 15.001 12.599 16.0864L10.5568 19.4999ZM11.7892 4.16715H11.6199C11.3898 4.16715 11.2033 4.3537 11.2033 4.58382V12.2931C11.2033 12.6167 11.4656 12.879 11.7892 12.879C12.1129 12.879 12.3752 12.6167 12.3752 12.2931V10.1803C13.2777 9.92446 13.9411 9.0936 13.9411 8.11016V6.31903C13.9411 5.1325 12.9758 4.16715 11.7892 4.16715ZM9.77066 4.16662C9.44704 4.16664 9.1847 4.42898 9.1847 4.7526V6.47982C9.1847 6.59595 9.09056 6.69009 8.97443 6.69009C8.85829 6.69009 8.76415 6.59595 8.76415 6.47982V4.75266C8.76415 4.42903 8.5018 4.16668 8.17818 4.16668C7.85455 4.16668 7.5922 4.42903 7.5922 4.75266V6.47984C7.5922 6.59596 7.49807 6.69009 7.38195 6.69009C7.26583 6.69009 7.17169 6.59596 7.17169 6.47984V4.75262C7.17169 4.42902 6.90936 4.16668 6.58575 4.16668C6.26215 4.16668 5.99982 4.42902 5.99982 4.75262V6.44274C5.99982 7.4409 6.67489 8.28379 7.59224 8.54047V12.2931C7.59224 12.6167 7.85459 12.8791 8.17821 12.8791C8.50184 12.8791 8.76419 12.6167 8.76419 12.2931V8.54039C9.68157 8.28379 10.3567 7.44086 10.3567 6.44266V4.7526C10.3567 4.42897 10.0943 4.16661 9.77066 4.16662Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.d176fbf794511185029d338284453a76.svg";
export { ForwardRef as ReactComponent };